import MenuIcon from "@mui/icons-material/Menu";
import { CustomIconButton } from "../icon-button";
export function MenuAnchorIcon() {
  return (
    <CustomIconButton>
      <MenuIcon />
    </CustomIconButton>
  );
}
